var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520-158.461v-72.308h72.308v72.308H520Zm-72.308-72.308v-176.923H520v176.923h-72.308Zm281.539-135.385V-480h72.308v113.846h-72.308ZM656.923-480v-72.308h72.308V-480h-72.308Zm-426.154 72.308V-480h72.308v72.308h-72.308ZM158.461-480v-72.308h72.308V-480h-72.308ZM480-729.231v-72.308h72.308v72.308H480ZM189.231-615.385h155.384v-155.384H189.231v155.384Zm-30.77 30.77v-216.924h216.924v216.924H158.461Zm30.77 395.384h161.538v-155.384H189.231v155.384Zm-30.77 30.77v-216.924h223.077v216.924H158.461Zm456.924-456.924h155.384v-155.384H615.385v155.384Zm-30.77 30.77v-216.924h216.924v216.924H584.615Zm72.308 426.154v-135.385h-72.308v-72.308h144.616v135.385h72.308v72.308H656.923ZM520-407.692V-480h136.923v72.308H520Zm-144.615 0V-480h-72.308v-72.308H520V-480h-72.308v72.308h-72.307Zm32.307-176.923v-144.616H480v72.308h72.308v72.308H407.692Zm-166.154-83.077v-50.77h50.77v50.77h-50.77Zm5.385 420.769v-50.769h50.769v50.769h-50.769Zm420.769-420.769v-50.77h50.77v50.77h-50.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr_code.f376da6357e09abf90d4b171d0fdec2d.svg";
export { ForwardRef as ReactComponent };